import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import { CurrentCartStoreService, CurrentPlanStoreService } from '@common/services';
import { agreementPayloadParts } from '@app/id-modal/agreement/agreement-payload.state';
import { AswContextType } from '@lib/interfaces';
import {
  ANA_BIZ_OFFICE_CODE,
  JAPANESE_REVENUE_OFFICE_CODE,
  ReservationFunctionIdType,
  ReservationPageIdType,
} from '@common/interfaces';

@Component({
  selector: 'asw-agreement-test',
  templateUrl: './agreement-test.html',
  styleUrls: ['../../test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgreementTestComponent extends SupportComponent {
  constructor(
    private common: CommonLibService,
    private _changeDetector: ChangeDetectorRef,
    private _currentPlanService: CurrentPlanStoreService,
    private modal: ModalService
  ) {
    super(common);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}

  agreement(lang?: string, thirdLanguageCode: string = 'de') {
    this._currentPlanService.updateCurrentPlan({
      creationPointOfSaleId: 'LAXNH08AA',
      // 有償日本オフィス "TYONH08AA";
      // 有償日本オフィスAPF "TYONH08AP";
      // 特典日本オフィス "TYONH08ZZ";
      // 日本統合オフィスコード "TYONH08";
    });
    if (lang) {
      this.common.aswContextStoreService.updateAswContext(
        lang
          ? { pointOfSaleId: JAPANESE_REVENUE_OFFICE_CODE, lang: lang }
          : { pointOfSaleId: JAPANESE_REVENUE_OFFICE_CODE }
      );
    }
    const part = agreementPayloadParts({
      isDisplayTerms: true,
      thirdLanguageCode: thirdLanguageCode,
    });
    this.modal.showSubPageModal(part);
    //*/
  }
  agreementApf(lang?: string, thirdLanguageCode: string = 'de') {
    this._currentPlanService.updateCurrentPlan({
      creationPointOfSaleId: 'LAXNH08AA',
    });
    this.common.aswContextStoreService.updateAswContext(
      lang ? { pointOfSaleId: 'TYONH08AP', lang: lang } : { pointOfSaleId: 'TYONH08AP' }
    );
    const part = agreementPayloadParts({
      isDisplayAPF: true,
      thirdLanguageCode: thirdLanguageCode,
    });
    this.modal.showSubPageModal(part);
  }

  agreementBiz(officeCode: string = JAPANESE_REVENUE_OFFICE_CODE, planOfficeCode = ANA_BIZ_OFFICE_CODE) {
    this._currentPlanService.updateCurrentPlan({
      creationPointOfSaleId: planOfficeCode,
    });
    this.common.aswContextStoreService.updateAswContext({ pointOfSaleId: officeCode });
    const part = agreementPayloadParts({
      isDisplayTerms: true,
      thirdLanguageCode: 'ja',
    });
    this.modal.showSubPageModal(part);
  }

  agreementBack() {
    this._currentPlanService.updateCurrentPlan({
      creationPointOfSaleId: 'LAXNH08AA',
    });
    const part = agreementPayloadParts({
      isDisplayTerms: true,
      thirdLanguageCode: 'ja',
      previousFunctionId: ReservationFunctionIdType.PRIME_BOOKING,
      previousPageId: ReservationPageIdType.PLAN_LIST,
    });
    this.modal.showSubPageModal(part);
  }
}
